var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'sw-Image-nativeLazyLoad',
    { 'sw-Image-placeholder': _vm.showPlaceholder },
    { 'sw-Image-LazyLoad-Loaded': _vm.nativeLazyLoaded },
    _vm.placeHolderRatio
  ]},[_c('img',_vm._b({staticClass:"sw-Image",attrs:{"loading":"lazy","src":_vm.src,"alt":_vm.alt,"srcset":_vm.dataSrcset},on:{"load":_vm.doneLoading}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }